import { render } from "./CheckRadioPage.vue?vue&type=template&id=e5c513ea&ts=true"
import script from "./CheckRadioPage.vue?vue&type=script&lang=ts"
export * from "./CheckRadioPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__